module.exports = __webpack_public_path__ + "img/toilet.e48b97ec.svg";